import { K, mono } from '../lib/theme'
import { fET, fUTC } from '../lib/format'
import type { Board } from '../lib/api'

const SESSION: Record<string, { label: string; dot: string }> = {
  open: { label: 'MARKET OPEN', dot: K.cy },
  closed: { label: 'MARKET CLOSED', dot: K.am },
  holiday: { label: 'HOLIDAY', dot: K.am },
  'half-day-closed': { label: 'MARKET CLOSED', dot: K.am },
}

export type View = 'board' | 'ticker' | 'heatmap' | 'method'

export function Header({ view, setView, board, now }: {
  view: View; setView: (v: View) => void; board: Board | null; now: Date
}) {
  const sess = SESSION[board?.session ?? 'closed'] ?? SESSION.closed
  const boardish = view === 'board' || view === 'ticker'
  const nav: [View, string][] = [['board', 'Live board'], ['heatmap', 'Heatmap'], ['method', 'Methodology']]

  return (
    <header style={{
      display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px 24px',
      padding: '12px clamp(16px,3vw,28px)', borderBottom: `1px solid ${K.line}`,
      background: 'rgba(7,9,15,.88)', position: 'sticky', top: 0, zIndex: 5, backdropFilter: 'blur(8px)',
    }}>
      <button onClick={() => setView('board')} aria-label="Offbell — live board" style={{ background: 'none', border: 0, padding: 0, color: K.txt, display: 'flex', alignItems: 'center', gap: 10, textAlign: 'left', cursor: 'pointer' }}>
        <svg width="26" height="26" viewBox="0 0 100 100" aria-hidden style={{ flex: 'none' }}>
          <path d="M20 62 H55" stroke={K.cy} strokeWidth={13} strokeLinecap="round" fill="none" />
          <path d="M55 62 L81 37" stroke={K.am} strokeWidth={13} strokeLinecap="round" fill="none" />
          <circle cx="55" cy="62" r="5.8" fill={K.txt} />
        </svg>
        <span style={{ fontSize: 18, fontWeight: 600, letterSpacing: '-.01em' }}>Offbell</span>
        <span className="ob-tag" style={{ fontFamily: mono, fontSize: 11, color: K.dim, letterSpacing: '.04em', alignSelf: 'flex-end', paddingBottom: 2 }}>stock token premium tracker</span>
      </button>

      <nav style={{ display: 'flex', gap: 2 }}>
        {nav.map(([v, label]) => {
          const on = v === 'board' ? boardish : view === v
          return (
            <button key={v} onClick={() => setView(v)} style={{
              background: 'none', border: 0, borderBottom: `2px solid ${on ? K.txt : 'transparent'}`,
              color: on ? K.txt : K.mut, padding: '8px 10px', fontSize: 14, cursor: 'pointer',
            }}>{label}</button>
          )
        })}
      </nav>

      <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px 16px', alignItems: 'center', flexWrap: 'wrap', fontFamily: mono, fontSize: 12, color: K.mut }}>
        <span className="ob-clock">{fUTC(now)}</span>
        <span className="ob-clock" style={{ color: K.faint }}>·</span>
        <span className="ob-clock">{fET(now)}</span>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, border: `1px solid ${K.line2}`, padding: '4px 10px', borderRadius: 2, color: K.txt, fontSize: 11, letterSpacing: '.05em' }}>
          <span style={{ width: 7, height: 7, borderRadius: '50%', background: sess.dot }} />{sess.label}
        </span>
      </div>
    </header>
  )
}
